const e = {
  fileGet: "GET /api/twin/v1/file",
  fileUploadPost: "POST /api/twin/v1/file/upload",
  fileCustomComponentResourceUploadPost: "POST /api/twin/v1/file/custom-component/resource/upload",
  fileMultipartInitPost: "POST /api/twin/v1/file/multipart/init",
  fileMultipartUploadPost: "POST /api/twin/v1/file/multipart/upload",
  fileMultipartCompletePost: "POST /api/twin/v1/file/multipart/complete",
  fileMultipartAbortPost: "POST /api/twin/v1/file/multipart/abort",
  fileModelPacketInitPost: "POST /api/twin/v1/file/model-packet/init",
  fileModelPacketUploadPost: "POST /api/twin/v1/file/model-packet/upload",
  fileModelPacketCompletePost: "POST /api/twin/v1/file/model-packet/complete",
  fileModelPacketAbortPost: "POST /api/twin/v1/file/model-packet/abort",
  fileHandlesGet: "GET /api/twin/v1/file/handles",
  fileHandlesPost: "POST /api/twin/v1/file/handles",
  fileHandlesDelete: "DELETE /api/twin/v1/file/handles",
  assetsGet: "GET /api/twin/v1/assets",
  assetsPost: "POST /api/twin/v1/assets",
  assetsPatch: "PATCH /api/twin/v1/assets",
  assetsFontsGet: "GET /api/twin/v1/assets/fonts",
  assetsAllGet: "GET /api/twin/v1/assets/all",
  assetIdGet: "GET /api/twin/v1/assets/{id}",
  assetIdPatch: "PATCH /api/twin/v1/assets/{id}",
  assetIdDelete: "DELETE /api/twin/v1/assets/{id}",
  assetCategoriesGet: "GET /api/twin/v1/asset-categories",
  assetCategoriesPost: "POST /api/twin/v1/asset-categories",
  assetCategorieIdPatch: "PATCH /api/twin/v1/asset-categories/{id}",
  assetCategorieIdDelete: "DELETE /api/twin/v1/asset-categories/{id}",
  projectsGet: "GET /api/twin/v1/projects",
  projectsDelete: "DELETE /api/twin/v1/projects",
  projectsCountGet: "GET /api/twin/v1/projects/count",
  projectsVideoProjectsGet: "GET /api/twin/v1/projects/video-projects",
  projectIdGet: "GET /api/twin/v1/projects/{id}",
  projectIdPatch: "PATCH /api/twin/v1/projects/{id}",
  projectsIdRecoverPatch: "PATCH /api/twin/v1/projects/{id}/recover",
  projectsPostV2: "POST /api/twin/v2/projects",
  projectsIdCopyPost: "POST /api/twin/v1/projects/{id}/copy",
  projectsImportPost: "POST /api/twin/v1/projects/import",
  projectsIdExportGet: "GET /api/twin/v1/projects/{id}/export",
  projectsIdTemporarySynchronizationCodeGet: "GET /api/twin/v1/projects/{id}/temporary/synchronization-code",
  projectsSynchronizePost: "POST /api/twin/v1/projects/synchronize",
  projectsIdSynchronizationCodePost: "POST /api/twin/v1/projects/{id}/synchronization-code",
  projectsDigitalTemplatePost: "POST /api/twin/v1/projects/digital/template",
  projectGroupsGet: "GET /api/twin/v1/project-groups",
  projectGroupsPost: "POST /api/twin/v1/project-groups",
  projectGroupsPatch: "PATCH /api/twin/v1/project-groups",
  projectGroupIdPatch: "PATCH /api/twin/v1/project-groups/{id}",
  projectGroupIdDelete: "DELETE /api/twin/v1/project-groups/{id}",
  projectsProjectIdScenesGet: "GET /api/twin/v1/projects/{projectId}/scenes",
  projectsSceneIdPatch: "PATCH /api/twin/v1/projects/scenes/{id}",
  scenesSceneIdObjsHierarchyPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/hierarchy",
  scenesSceneIdObjsHierarchyPatchV2: "PATCH /api/twin/v2/scenes/{sceneId}/objs/hierarchy",
  scenesSceneIdObjsHierarchyConfigPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/hierarchy/config",
  scenesSceneIdObjsGet: "GET /api/twin/v1/scenes/{sceneId}/objs",
  scenesSceneIdObjsPost: "POST /api/twin/v1/scenes/{sceneId}/objs",
  scenesSceneIdObjsPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs",
  scenesSceneIdObjsDeletedGet: "GET /api/twin/v1/scenes/{sceneId}/objs/deleted",
  scenesSceneIdObjIdGet: "GET /api/twin/v1/scenes/{sceneId}/objs/{id}",
  scenesSceneIdObjIdPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{id}",
  scenesSceneIdObjsGatherPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/gather",
  scenesSceneIdObjsRecoverPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/recover",
  scenesSceneIdObjsRemovePost: "POST /api/twin/v1/scenes/{sceneId}/objs/remove",
  scenesSceneIdObjsIdCopyPost: "POST /api/twin/v1/scenes/{sceneId}/objs/{id}/copy",
  scenesSceneIdObjsCopyPost: "POST /api/twin/v1/scenes/{sceneId}/objs/copy",
  scenesSceneIdObjsObjIdSplitPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/split",
  scenesSceneIdObjsComponentsStatesPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/components/states",
  scenesSceneIdObjsComponentsVersionsPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/components/versions",
  scenesSceneIdObjsVideoProjectPost: "POST /api/twin/v1/scenes/{sceneId}/objs/video-project",
  scenesSceneIdObjsComponentsRelsGet: "GET /api/twin/v1/scenes/{sceneId}/objs/components/rels",
  scenesSceneIdObjsIdCopyPostV2: "POST /api/twin/v2/scenes/{sceneId}/objs/{id}/copy",
  scenesSceneIdObjsCopyPostV2: "POST /api/twin/v2/scenes/{sceneId}/objs/copy",
  scenesSceneIdObjsGatherPatchV2: "PATCH /api/twin/v2/scenes/{sceneId}/objs/gather",
  scenesSceneIdObjsComponentsPatchV2: "PATCH /api/twin/v2/scenes/{sceneId}/objs/components",
  spaceGet: "GET /api/twin/v1/space",
  usersMeGet: "GET /api/twin/v1/users/me",
  usersAccessKeyGet: "GET /api/twin/v1/users/access-key",
  usersAccessKeyPost: "POST /api/twin/v1/users/access-key",
  usersAccessKeyPatch: "PATCH /api/twin/v1/users/access-key",
  usersAccessKeyDelete: "DELETE /api/twin/v1/users/access-key",
  usersAccessKeyListGet: "GET /api/twin/v1/users/access-key/list",
  usersAccessKeyRefreshPatch: "PATCH /api/twin/v1/users/access-key/refresh",
  resourceResourceCategoryGet: "GET /api/twin/v1/resource/resource-category",
  resourceStaticMaterialGet: "GET /api/twin/v1/resource/static-material",
  resourceGet: "GET /api/twin/v1/resource",
  resourcePost: "POST /api/twin/v1/resource",
  resourceDelete: "DELETE /api/twin/v1/resource",
  resourceIdPatch: "PATCH /api/twin/v1/resource/{id}",
  officialResourcesGet: "GET /api/twin/v1/official-resources",
  officialResourcesPost: "POST /api/twin/v1/official-resources",
  officialResourcesPatch: "PATCH /api/twin/v1/official-resources",
  officialResourcesDelete: "DELETE /api/twin/v1/official-resources",
  officialResourcesCategoryGet: "GET /api/twin/v1/official-resources/category",
  officialResourcesCategoryPost: "POST /api/twin/v1/official-resources/category",
  officialResourcesCategoryDelete: "DELETE /api/twin/v1/official-resources/category",
  officialResourcesAddIdUsedTimesPost: "POST /api/twin/v1/official-resources/add/{id}/usedTimes",
  officialResourcesAllGet: "GET /api/twin/v1/official-resources/all",
  officialResourceIdPatch: "PATCH /api/twin/v1/official-resources/{id}",
  officialResourcesCategoryIdPatch: "PATCH /api/twin/v1/official-resources/category/{id}",
  scenesSceneIdResourcesGet: "GET /api/twin/v1/scenes/{sceneId}/resources",
  scenesSceneIdResourcesPost: "POST /api/twin/v1/scenes/{sceneId}/resources",
  scenesSceneIdResourcesPatch: "PATCH /api/twin/v1/scenes/{sceneId}/resources",
  scenesSceneIdResourcePost: "POST /api/twin/v1/scenes/{sceneId}/resource",
  scenesSceneIdResourceIdPatch: "PATCH /api/twin/v1/scenes/{sceneId}/resources/{id}",
  scenesSceneIdRemoveResourcesPost: "POST /api/twin/v1/scenes/{sceneId}/remove/resources",
  shareProjectProjectIdGet: "GET /api/twin/v1/share/projects/{projectId}",
  shareProjectsProjectIdSceneSceneIdGet: "GET /api/twin/v1/share/projects/{projectId}/scenes/{sceneId}",
  scenesSceneIdObjsObjIdComponentsGet: "GET /api/twin/v1/scenes/{sceneId}/objs/{objId}/components",
  scenesSceneIdObjsObjIdComponentsPost: "POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components",
  scenesSceneIdObjsObjIdComponentsPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components",
  scenesSceneIdObjsObjIdComponentsDelete: "DELETE /api/twin/v1/scenes/{sceneId}/objs/{objId}/components",
  scenesSceneIdObjsObjIdComponentsIdRelsGet: "GET /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels",
  scenesSceneIdObjsObjIdComponentsIdRelsPost: "POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels",
  scenesSceneIdObjsObjIdComponentsIdRelsPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels",
  scenesSceneIdObjsObjIdComponentsIdRelsDelete: "DELETE /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/rels",
  scenesSceneIdObjsObjIdReplaceComponentsPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/replace/components",
  scenesSceneIdObjsObjIdComponentsVersionsPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/versions",
  scenesSceneIdObjsObjIdComponentIdPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}",
  scenesSceneIdObjsObjIdComponentsIdVersionPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{id}/version",
  scenesSceneIdObjsObjIdComponentsIdRelRelIdPatchV2: "PATCH /api/twin/v2/scenes/{sceneId}/objs/{objId}/components/{id}/rels/{relId}",
  scenesSceneIdObjsObjIdComponentsSortPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/sort",
  scenesSceneIdObjsObjIdComponentsIdRelsDeleteV2: "DELETE /api/twin/v2/scenes/{sceneId}/objs/{objId}/components/{id}/rels",
  scenesSceneIdObjsObjIdComponentsDataCopyPost: "POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/data/copy",
  scenesSceneIdObjsObjIdComponentsComponentIdStatesSortPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states/sort",
  scenesSceneIdObjsObjIdComponentsComponentIdStateIdPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states/{id}",
  scenesSceneIdObjsObjIdComponentsComponentIdStatesPatch: "PATCH /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states",
  scenesSceneIdObjsObjIdComponentsComponentIdStatesPost: "POST /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states",
  scenesSceneIdObjsObjIdComponentsComponentIdStatesDelete: "DELETE /api/twin/v1/scenes/{sceneId}/objs/{objId}/components/{componentId}/states",
  customComponentsGet: "GET /api/twin/v1/custom/components",
  customComponentsDelete: "DELETE /api/twin/v1/custom/components",
  customComponentsUploadPost: "POST /api/twin/v1/custom/components/upload",
  customComponentIdDelete: "DELETE /api/twin/v1/custom/components/{id}",
  scenesSceneIdComponentsPostV2: "POST /api/twin/v2/scenes/{sceneId}/components",
  scenesSceneIdComponentsPatchV2: "PATCH /api/twin/v2/scenes/{sceneId}/components",
  scenesSceneIdComponentsRemovePostV2: "POST /api/twin/v2/scenes/{sceneId}/components/remove"
};
export {
  e as apis
};
